import React, { Component } from 'react';
import { Row, Col } from 'antd';
import { config } from '../../utils/components/afspHeader';
import AfspLogo from './AfspLogo';
import AfspTitle from './AfspTitle';
import AfspControls from './AfspControls';

export default class AfspHeader extends Component {
    constructor(props) {
        super(props);

        // State for handling the login modal.
        this.state = {
            modal: {
                visible: false,
                view: 'login',
                loginAttempts: 0
            }
        }

        this.controls = {
            resetDisplay: () => {
                const
                { state } = this,
                { modal } = state;

                if(modal.view !== 'login')
                    this.setState({...state,
                        modal: {...modal, view: 'login' }
                    });
            },
            handleDisplay: () => {
                var { modal } = this, { visible } = modal;
                this.setState({...state,
                    modal: {...modal, visible: !visible }
                });
            },
            changeModal: (view) => {
                var { modal } = this.state;
                this.setState({...state,
                    modal: {...modal, view: view }
                });
            }
        }
    }

    render() {
        const
        { row, col1, col2, col3 } = config,
        { props } = this,
        { size, images, state, services } = props;

        return (
            <div>
                <Row {...row.props} style={{...row.style[size]}}>
                    <Col {...col1.props} style={{...col1.style[size]}}>
                        <span style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                            <AfspLogo size={size} images={images} />
                        </span>
                    </Col>
                    <Col {...col2.props} style={{...col2.style[size], textAlign: 'center' }}>
                        <AfspTitle size={size} />
                    </Col>
                    <Col {...col3.props} style={{...col3.style[size]}}>
                        <AfspControls 
                            {...props} 
                            state={state}
                            services={services}
                            modal={this.state.modal} 
                            controls={this.controls} 
                        />
                    </Col>
                </Row>
            </div>
        )
    }
}
